<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="5">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.searchKey"
              :placeholder="'Search here...'"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l("INDEX.advanced_search") || "高级搜索" }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="exportFile"
              v-if="allow('E')"
            >
              <b-icon-cloud-download></b-icon-cloud-download
              >{{ $l("btn_export") || "导出" }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="medium">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_project_name') || '项目名称'">
              <el-input
                v-model="form.projectTitle"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_department_name') || '部门名称'"
            >
              <el-input
                v-model="form.departmentName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_project_of_head') || '项目负责人'"
            >
              <el-input
                v-model="form.projectOwnerName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_project_status') || '项目状态'"
            >
              <el-input
                v-model="form.projectStatusDesc"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_list_of_participants') || '参与人名单'"
            >
              <el-input
                v-model="form.projectParticipant"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-form-item :label="$l('table_label_create_date') || '创建时间'">
            <br/>
            <el-col :span="11">
              <el-date-picker
                v-model="form.createDateStrBegin"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width:100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2" style="text-align:center">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.createDateStrEnd"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width:100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l("INDEX.btn_cancel_query") || "取消查询"
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l("INDEX.btn_reset_filter") || "重置条件"
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l("INDEX.btn_data_retrieval") || "数据检索"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  searchKey: "",
};

export default {
  data() {
    return {
      advqueryDialogVisible:false,
      form: {
        ...initForm,
      },
    };
  },
  methods: {
    onReset() {
      this.form = {
        ...initForm,
      };
      this.$emit("reset");
      this.query();
    },
    query() {
      this.$emit("submit", this.form);
    },
    exportFile() {
      let url = "/digitalCenter/report/export/projectInfoList";
      let fileName = "项目情况一览分析";
      this.$api.globalExportData(url, this.form, fileName);
    },
    // 高级查询
    advquery() {
      this.form.searchKey = "";
      this.query();
      this.closeAdvqueryDialog();
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm };
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true;
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false;
    },
  },
  created() {
    this.onReset();
  },
  activated() {
    this.onReset();
  },
};
</script>
